<template>
    <div>
        <p class="filter-title">Brand</p>
            <div class="checkbox" v-for="brand in brands" :key="brand.key">
                <label>
                    <input type="checkbox" v-model="selected" :value="brand.key" @change="bump">
                    <span class="faux-label">
                        {{ brand.key ? brand.key : 'Unbranded' }}
                        <span class="product-count">({{ brand.doc_count }})</span>
                    </span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductPrice from '../../Product/ProductPrice.vue';
    import { BrandFilter } from '../../../Services/Search/BrandFilter.js';

    export default {
        components: {
            ProductPrice
        },
        props: {
            items: {
                type: [Object,Array],
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                selected: [],
                brands: [],
            }
        },
        mounted() {
            this.brands = this.items.all;
            if (this.items.selected) {
                _.each(this.items.selected, item => {
                    this.selected.push(item.key);
                });
                this.loaded();
            }
        },
        methods: {
            bump() {
                this.$emit('bump', new BrandFilter(this.selected));
            },
            loaded() {
                this.$emit('loaded', new BrandFilter(this.selected));
            }
        },
        computed: {
            rows() {
                return this.brands.buckets;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/Filters/BrandFilter.vue